module.exports = __webpack_public_path__ + "img/02.2c6fc44b.png";